export const CLASS_NAMES = ["person", "car", "truck", "bicycle", "bus", "motorcycle", "boat"] as const;
export type ClassName = typeof CLASS_NAMES[number];
